import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits, parseEther } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseUsdc1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdcAddress = Environment.usdc;

  const purchaseUsdc1 = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      amount = parseFloat(amount).toFixed(6);
      let roundedAmount = Math.round(amount * 1e12) / 1e12;
      const nd = parseUnits(roundedAmount.toString(), 6);

      let minValue = Math.round(parseFloat(min * 0.99).toFixed(6) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithToken",
          args: [
            UsdcAddress,
            nd,
            postApiRes.code,
            postApiRes?.normalizationFactor,
            postApiRes.referenceTokenPrice,
            minValue,
            id,
            postApiRes?.price,
            postApiRes.deadline,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("USDC1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("USDC1 purchase confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("USDC1 purchase error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseUsdc1 };
};

export default usePurchaseUsdc1;
